<app-header></app-header>
<div class="title"></div>
<div class="margin-top-70">
  <div class="container">
    <div class="row">
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Status
              </td>
              <td>
                <app-drop-down-single-select
                  [DropDownOptions]="dropdownListStatus"
                  (typeSelectedChanged)="updateSelectedType($event)"
                  [name]="'status'"
                ></app-drop-down-single-select>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Product ID
              </td>
              <td colspan="2">
                <input
                  type="text"
                  class="form-control"
                  [(ngModel)]="productId"
                  placeholder=""
                />
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Book Type
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'bookType'"
                  [DropDownOptions]="listBookType"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Product Format
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'productFormat'"
                  [DropDownOptions]="productFormat"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Published Date
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'publishedDate'"
                  [DropDownOptions]="datesData"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
            </tr>
            <tr>
              <td class="v-align-m">
                Contracted Date
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'contractedDate'"
                  [DropDownOptions]="datesData"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div class="container">
  <div class="" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Portfolio</th>
          <th scope="col">Product ID</th>
          <th scope="col">Title</th>
          <th scope="col">Product Format</th>
          <th scope="col">Book Type</th>
          <th scope="col">EPD</th>
          <th scope="col">ISBN-13P</th>
          <th scope="col">ISBN-10P</th>
          <th scope="col">ISBN-13E</th>
          <th scope="col">ISBN-10E</th>
          <th scope="col">Publishing Department</th>
          <th scope="col">Brand Id</th>
          <th scope="col">Publisher Name</th>
          <th scope="col">Acquisition Editor</th>
          <th scope="col">Contracting AE</th>
          <th scope="col">Topic</th>
          <th scope="col">Published Date</th>
          <th scope="col">Page count</th>
          <th scope="col">Brand</th>
          <th scope="col">Status</th>
          <th scope="col">Contracted Date</th>
          <th scope="col">Cancelled Date</th>
          <th scope="col">Commercial Priority</th>
          <th scope="col">E-Book Price</th>
          <th scope="col">Print Price</th>
          <th scope="col">CM Category</th>
          <th scope="col">IEPD</th>
          <th scope="col">DDPD</th>
          <th scope="col">Final Page Count</th>
          <th scope="col">Final Printers Uploaded Date</th>
          <th scope="col">Commit Date</th>
          <th scope="col">Revised Commit Date</th>
          <th scope="col">Second Revised Commit Date</th>
          <th scope="col">Is a Derivative Product</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.portfolio}}</td>
          <td>{{product.part_number}}</td>
          <td>{{product.product_name}}</td>
          <td>{{product.product_format}}</td>
          <td>{{product.book_type}}</td>
          <td>{{product.epd}}</td>
          <td>{{product.isbn_13}}</td>
          <td>{{product.isbn_10}}</td>
          <td>{{product.isbn_13e}}</td>
          <td>{{product.isbn_10e}}</td>
          <td>{{product.team_name}}</td>
          <td>{{product.brand_id}}</td>
          <td>{{product.Publisher}}</td>
          <td>{{product.AE}}</td>
          <td>{{product.contracting_ae}}</td>
          <td>{{product.book_topic}}</td>
          <td>{{product.publishing_date}}</td>
          <td>{{product.length_book}}</td>
          <td>{{product.brand}}</td>
          <td>{{product.product_status}}</td>
          <td>{{product.contracted_date}}</td>
          <td>{{product.cancelled_date}}</td>
          <td>{{product.commercial_priority}}</td>
          <td>{{product.ebookpriceusd}}</td>
          <td>{{product.price}}</td>
          <td>{{product.cm_category}}</td>
          <td>{{product.edd}}</td>
          <td>{{product.ddpd}}</td>
          <td>{{product.final_length_book}}</td>
          <td>{{product.fpup}}</td>
          <td>{{product.commit_date}}</td>
          <td>{{product.revised_commit_date}}</td>
          <td>{{product.second_revised_commit_date}}</td>
          <td>{{product.is_derivative === 1 ? 'true' : 'false' }}</td>
        </tr>
      </tbody>
    </table>
    <!-- Total Products {{totalProducts}} -->
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
